module.exports = __webpack_public_path__ + "img/primo.bfd0d3ed.png";